export default function page_not_found(json = null) {
    return `
        <h1>404</h1>
    `;
}